import { render, staticRenderFns } from "./ClosureList.vue?vue&type=template&id=bc95e802&"
import script from "./ClosureList.vue?vue&type=script&lang=js&"
export * from "./ClosureList.vue?vue&type=script&lang=js&"
import style0 from "./ClosureList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports